import './ForgotPasswordPage.scss';

import React from 'react';
import { connect } from "react-redux";
import { routerActions } from "react-router-redux";
import update from 'immutability-helper';

import { postForgotPassword, setCredentials } from 'containers/Auth/store/actions';

import A from 'components/A';
import Button from 'components/Button';
import ForgotPasswordForm from './ForgotPasswordForm';
import Modal from 'components/Modal';
import PageContent from 'components/PageContent';

class ForgotPasswordPage extends React.Component {
    constructor() {
        super();

        this.state = {
            showConfirmModal: false
        };
    }

    componentDidMount() {
        document.body.classList.add('auth-page');
        document.body.classList.add('forgot-password-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
        document.body.classList.remove('forgot-password-page');
    }

    handleChange(name, value) {
        let newCredentialsObj = update(this.props.auth.credentials, {
            email: {$set: value}
        });

        this.props.setCredentials(newCredentialsObj);
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            this.props.postForgotPassword()
                .then((res) => {
                    if(res.status === 204) {
                        this.setState({showConfirmModal: true})
                    }
                });
        }
    }

    render() {
        return (
            <PageContent className="forgot-password-content">
                <div className="login-form--wrapper auth-form--wrapper">

                    <ForgotPasswordForm
                        credentials={this.props.auth.credentials}
                        error={this.props.auth.sendForgotPasswordEmailError}
                        handleChange={this.handleChange.bind(this)}
                        isSubmitting={this.props.auth.isSendingForgotPasswordEmail}
                        onInvalid={this.handleSubmit.bind(this, false)}
                        onValid={this.handleSubmit.bind(this, true)}
                    />

                    <div className="auth-page__links">
                        <A to="/login">Back to Login</A> / <A to="/request-invitation">Request Invitation</A>
                    </div>
                </div>

                <Modal closeModal={() => this.setState({showConfirmModal: false})}
                       show={this.state.showConfirmModal === true}
                       title="Check your email inbox!">
                    <p>
                        If your email matches an account in our system, you will be sent an email with instructions on how to reset your password.
                    </p>
                    <div className="c-modal__button-wrapper">
                        <Button onClick={() => this.setState({showConfirmModal: false})}>
                            OK
                        </Button>
                    </div>
                </Modal>
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        postForgotPassword: () => dispatch(postForgotPassword()),
        setCredentials: (credentialsObj) => dispatch(setCredentials(credentialsObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/ForgotPasswordPage/index.js